module.exports = __webpack_public_path__ + "static/img/technology-1-SD-WAN-img-3.7240686.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology-1-SD-WAN-img-3.jpg
// module id = Zwso
// module chunks = 0